// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-container[data-v-4e5c5c97]:after{content:\"\";display:block;padding-bottom:102%}.text[data-v-4e5c5c97]{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;max-height:2.5em;min-height:2.5em}.price-field[data-v-4e5c5c97]{min-height:1.25em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
